import PropTypes from 'prop-types';
import { getPatientConsentStatus } from 'utils';

const ConsentIndicator = ({ ccmConsentFormStatus }) => {
  const consentStatus = ccmConsentFormStatus ? 'confirmed' : 'not_confirmed';
  const consent = ccmConsentFormStatus
    ? 'Consent Confirmed'
    : 'Consent Not Confirmed';
  const { color } = getPatientConsentStatus(consentStatus);
  return (
    <div style={{ backgroundColor: color }} className="ccm-status-indicator">
      {consent}
    </div>
  );
};

ConsentIndicator.propTypes = {
  ccmConsentFormStatus: PropTypes.bool,
};

export default ConsentIndicator;
